import React from 'react'
import { Document, Font, Image, Page, StyleSheet, View, Text  } from '@react-pdf/renderer'
import moment from 'moment'
import FormGroup from './FormGroup'
import FormHeading from './FormHeading'
import Header from './Header'

Font.register({
  family: 'Lato-Bold',
  src: '/fonts/lato-v15-latin-700.ttf',
})

Font.register({
  family: 'Lato-Regular',
  src: '/fonts/lato-v15-latin-regular.ttf',
})

const TGOPdfDocument = ({ guiaServico, urlLogo }) => {
  const paginas = [];
  const guiaServicoTgoTussViews = [...guiaServico.guiaServicoTGOTussViews];
  
      if (guiaServicoTgoTussViews.length >= 5) {
          let last = false;
          let count = 0;
          let tussViewsSeparadaPorPagina = [];
          guiaServicoTgoTussViews.forEach((item, index) => {
              count = count + 1;
              last = guiaServicoTgoTussViews.length === index + 1;
  
              tussViewsSeparadaPorPagina.push(item);
  
              if (count === 4 || last) {
                  count = 0;
                  paginas.push({
                      ...guiaServico,
                      guiaServicoTgoTussViews: [...tussViewsSeparadaPorPagina],
                  });
                  tussViewsSeparadaPorPagina = [];
                  return;
              }
          });
      } else {
          paginas.push(guiaServico);
      }
  
      return (
          <Document>
              {paginas.map((item, index) => (
                  <Pagina key={index} guiaServico={item} urlLogo={urlLogo}/>
              ))}
          </Document>
      );
}

const verificaRN = dataNascimento => {
    if (dataNascimento !== ""){
        const diaAtual = moment();
        const idadeEmDias = diaAtual.diff(dataNascimento, "days");
        return idadeEmDias <= 28 ? "S" : "N"
    }
};

const Pagina = ({ guiaServico, urlLogo }) => {
  return (
      <Page style={styles.page} orientation='landscape' size='A4'>
        <View style={styles.container}>
          {!!urlLogo && (
            <View style={styles.contentLogo}>
              <Image alt='Logo' src={urlLogo} style={styles.logo} />
            </View>
          )}
          <Header titulo='GUIA TRATAMENTO ODONTOLÓGICO' numeroGuiaPrestador='' />

          <View style={styles.formGroupContainer}>
            <FormGroup
              label='1 - Registro ANS'
              maxLength={6}
            />
            <FormGroup
              label='3 - Número da Guia Principal'
              maxLength={20}
            />
            <FormGroup
              label='4 - Data de Autorização'
              type='date'
              maxLength={10}
            />
            <FormGroup label='5 - Senha' maxLength={15}  />
            <FormGroup
              label='6 - Data de Validade da Senha'
              type='date'
              maxLength={10}
            />
            <FormGroup
              label='7 - Número da Guia Atribuída pela Operadora'
              maxLength={20}
            />
          </View>

          <FormHeading label='Dados do Beneficiário:' />
          <View style={styles.formGroupContainer}>
            <FormGroup
              label='8 - Número da Carteira'
              value={guiaServico?.beneficiarioConvenioNumeroCarteira || ''}
              maxLength={20}
            />
            <FormGroup
              label='9 - Plano'
              maxLength={20}
            />
            <FormGroup
              label='10 - Empresa'
              maxLength={20}
            />
            <FormGroup
              label='11 - Validade da Carteira'
              type='date'
              value={
                  guiaServico?.beneficiarioConvenioValidadeCarteira ? 
                      moment(guiaServico?.beneficiarioConvenioValidadeCarteira).format("DD/MM/YYYY") 
                      : 
                      ""
              }
              maxLength={10}
            />
          </View>

          <View style={styles.formGroupContainer}>
            <FormGroup
                label='57 - Nome Social'
                maxLength={40}
              />
          </View>

          <View style={styles.formGroupContainer}>
            <FormGroup
              label='13 - Nome'
              maxLength={30}
              value={guiaServico?.beneficiarioNome || ""}
              style={{ flex: 2 }}
            />
            <FormGroup
              label='14 - Telefone'
              maxLength={15}
            />
            <FormGroup
              label='15 - Nome do titular do Plano'
              maxLength={30}
              style={{ flex: 2 }}
            />
            <FormGroup
              label='16 - Atendimento RN'
              value={verificaRN(guiaServico.sujeitoAtencao?.dataNascimento || "")}
              maxLength={1}
            />
          </View>
          
          <FormHeading label='Dados do Contratado Responsável pelo Tratamento' />
          <View style={styles.formGroupContainer}>
            <FormGroup
              label='17 - Nome do Profissional Solicitante'
              maxLength={60}
              value={guiaServico?.solicitanteNome || ""}
              style={{ flex: 2 }}
            />
            <FormGroup
              label='18 - Número no CRO'
              maxLength={15}
            />
            <FormGroup
              label='19 - UF'
              maxLength={2}
              value={guiaServico.profissionalSaude?.ufConselho || ""}
            />
            <FormGroup
              label='20 - Código CBO'
              maxLength={6}
            />
          </View>

          <View style={styles.formGroupContainer}>
            <FormGroup
              label='21 - Código na Operadora'
              maxLength={14}
            />
            <FormGroup
              label='22 - Nome do Contratado Executante'
              maxLength={45}
              style={{ flex: 2 }}
            />
            <FormGroup
              label='23 - Número no CRO'
              maxLength={15}
            />
            <FormGroup
              label='24 - UF'
              maxLength={2}
            />
            <FormGroup
              label='25 - Código CNES'
              maxLength={7}
              value={guiaServico?.contratado?.cnes}
            />
          </View>

          <View style={styles.formGroupContainer}>
            <FormGroup
              label='26 - Nome do Profissional Executante'
              maxLength={60}
              style={{ flex: 2 }}
            />
            <FormGroup
              label='27 - Número no CRO'
              maxLength={15}
            />
            <FormGroup
              label='28 - UF'
              maxLength={2}
            />
            <FormGroup
              label='29 - Código CBO'
              maxLength={6}
            />
          </View>

          <FormHeading label='Nome de Profissional/Profissional Substituto / Procedimentos Executados' />
          <View style={styles.formGroupContainerBorder}>
              {guiaServico?.guiaServicoTGOTussViews?.length > 0 && guiaServico?.guiaServicoTGOTussViews?.map((item, index) => (
                <View key={index} style={[styles.formGroupContainer, { marginBottom: 0}]}>
                      <FormGroup
                        label={index !== 0 ? undefined : '30 - Tabela'}
                        maxLength={2}
                        showRowNumber
                        startRowNumber={index + 1}
                        value={item?.tussView?.tabela || ""}
                        style={[
                            styles.formGroupRows,
                            styles.formGroupNoMarginLeft,
                            styles.formGroupTabela,
                        ]}
                      />
                      <FormGroup
                        label={
                          index !== 0
                              ? undefined
                              : "31 - Código de Procedimento"
                        }
                        maxLength={10}
                        value={item?.tussView?.codigoTermo || ""}
                        style={[
                          styles.formGroupRows,
                          styles.formGroupCodigoTermo,
                        ]}
                      />
                      <FormGroup
                        label={
                            index !== 0 ? undefined : "32 - Descrição"
                        }
                        maxLength={5}
                        style={[
                          styles.formGroupRows,
                          styles.formGroupDescricao,
                        ]}
                      />
                      <FormGroup
                        label={index !== 0 ? undefined : '33 - Dente/Região'}
                        maxLength={8}
                        style={[
                          styles.formGroupRows,
                          styles.formGroupCodigoTermo,
                        ]}
                        value={item?.localOdontograma?.tipo || ""}
                      />
                      <FormGroup
                        label={index !== 0 ? undefined : '34 - Face'}
                        maxLength={10}
                        style={[
                          styles.formGroupRows,
                          styles.formGroupCodigoTermo,
                        ]}
                        value={item?.face || ""}
                      />
                      <FormGroup
                        label={index !== 0 ? undefined : '35 - Qtde'}
                        maxLength={3}
                        style={[
                          styles.formGroupRows,
                          styles.formGroupQtdeSolic,
                        ]}
                        value={item?.quantidadeSolicitada || ""}
                      />

                      <FormGroup
                        label='36 - Qtde US.'
                        maxLength={3}
                        style={[
                            styles.formGroupRows,
                            styles.formGroupQtdeAut,
                        ]}
                        value={item?.quantidadeSolicitadaUnidadeServico || ""}
                      />
                      <FormGroup
                        label='37 - Valor R$'
                        type='currency'
                        maxLength={5}
                        noBorder
                        style={[styles.formGroupRows, styles.formGroupNoMarginLeft]}
                      />
                      <FormGroup
                        label='38 - Franquia R$'
                        type='currency'
                        maxLength={5}
                        noBorder
                        style={[styles.formGroupRows, styles.formGroupNoMarginLeft]}
                      />
                      <FormGroup
                        label='39- Aut'
                        maxLength={2}
                        noBorder
                        style={[styles.formGroupRows, styles.formGroupNoMarginLeft]}
                      />
                      <FormGroup
                        label='40- Cod. Negativa'
                        maxLength={2}
                        noBorder
                        style={[styles.formGroupRows, styles.formGroupNoMarginLeft]}
                      />
                      <FormGroup 
                        label='41 - Data de realização' 
                        type='date'
                        maxLength={10}
                        noBorder  
                        style={[styles.formGroupRows, styles.formGroupNoMarginLeft]} />

                      <FormGroup
                        label='42 - Assinatura'
                        maxLength={5}
                        noBorder
                        style={[styles.formGroupRows, styles.formGroupNoMarginLeft]}
                      />
                </View>
              ))}
          </View>

          <View style={styles.formGroupContainer}>
            <FormGroup
              label='43 - Data de Término do Tratamento'
              type='date'
              maxLength={15}
              noBorder
              style={[styles.formGroupAssinatura, { flex: 2 }]}
            />
            <FormGroup
              label='44 - Tipo de Atendimento'
              maxLength={15}
              noBorder
              style={[styles.formGroupAssinatura, { flex: 2 }]}
            />
            <FormGroup
              label='45 - Tipo de Faturamento'
              maxLength={15}
              noBorder
              style={[styles.formGroupAssinatura, { flex: 2 }]}
            />
            <FormGroup
              label='46 - Total de quantidade US'
              type='currency'
              maxLength={15}
              noBorder
              style={[styles.formGroupAssinatura, { flex: 2 }]}
            />
            <FormGroup
              label='47 - Valor Total (R$)'
              type='currency'
              maxLength={15}
              noBorder
              style={[styles.formGroupAssinatura, { flex: 2 }]}
            />
            <FormGroup
              label='48 - Valor Total Franquia (R$)'
              type='currency'
              maxLength={15}
              noBorder
              style={[styles.formGroupAssinatura, { flex: 2 }]}
            />
          </View>

          <View style={styles.formGroupContainer}>
            <Text style={{ fontSize: 6, fontFamily: 'Lato-Bold', marginTop: 6, marginBottom: 6}}>
             Declaro, que após ter sido devidamente estratégico sobre os propósitos, todos, custos e alternativas de tratamento, conforme núma generalizada, sobre o exercício do tratamento, comprometendo-se a cumprir as orientações do profissional assistente e aviso com os custos previstos em contrário. Declaro, ainda, que o(s) procedimento/sistema total se não a por mim estabelece, efetivamente, qualquer outro documento entre o diretora transferida. Acredito à Operação a pagar um mês nome e por minha conta, no profissional destinado que passas esse documento, os valores referentes ao tratamento realizado, comprometendo-me a errar com os custos conforme previsto em contrário.
            </Text>
          </View>

          <View style={styles.formGroupContainer}>
            <FormGroup
              label='49 - Observação / Justificativa'
              noBorder
              type='textarea'
              style={styles.textarea}
            />
          </View>

          <View style={styles.formGroupContainer}>
            <FormGroup
              label='50 - Data e Assinatura do Cirurgião Dentista'
              maxLength={10}
              type='date'
            />
            <FormGroup
              label='51 - Assinatura do Cirurgião Dentista Solicitante'
              noBorder
              maxLength={30}
            />
            <FormGroup
              label='52 - Data e Assinatura do Cirurgião Dentista'
              maxLength={10}
              type='date'
            />
            <FormGroup
              label='53 - Assinatura do Cirurgião Dentista Solicitante'
              maxLength={25}
              noBorder
            />
          </View>
          <View style={styles.formGroupContainer}>
            <FormGroup
                label='54 - Data e Assinatura do Beneficiário'
                maxLength={10}
                type='date'
              />
              <FormGroup
                label='55 - Assinatura do Beneficiário ou Responsável'
                maxLength={30}
                noBorder
              />
            <FormGroup
                label='56 - Data do Carimbo da empresa'
                maxLength={10}
                type='date'
              />
          </View>
        </View>
      </Page>
  )
}

const styles = StyleSheet.create({
  page: {
    padding: 15,
  },
  container: {
    borderWidth: 1,
    borderColor: '#707070',
    paddingHorizontal: 10,
    paddingVertical: 8,
  },
  formGroupContainer: {
    flexDirection: 'row',
    marginBottom: 1.5,
    alignItems: 'flex-end',
  },
  formGroupContainerBorder: {
    borderColor: '#707070',
    borderWidth: 0.5,
    marginLeft: 2,
    marginRight: 2,
  },
  formGroupRow: {
    flex: 1,
    marginRight: 2,
  },
  formGroupTotal: {
    marginLeft: 'auto',
    width: 150,
  },
  formGroupAssinatura: {
    flex: 1,
    marginRight: 10,
  },
  contentLogo: {
    position: 'absolute',
    top: 4,
    left: 10,
  },
  logo: {
    maxHeight: '25px',
    maxWidth: '90px',
  },
  textarea: {
    backgroundColor: '#F9F9F9',
    flex: 1,
    height: 35,
    justifyContent: 'start',
  },
  formGroupRows: {
    borderWidth: 0,
  },
  formGroupNoMarginLeft: {
    marginLeft: 0,
  },
})

export default TGOPdfDocument
